import styled, { css } from 'styled-components';

import { Image } from 'shared/components/Image';
import { t } from 'localization/utils/t';

const TP = 'productTemplate.components.robotGallery.RobotImage';

interface IRobotImageProps {
  isSelected: boolean;
  url: string;
  handleClick: () => void;
  productName: string;
}

export const RobotImage = ({ isSelected, url, handleClick, productName }: IRobotImageProps) => (
  <RobotImage.Wrapper data-qa="robot_image_wrapper" isSelected={isSelected}>
    <Image
      alt={t(`${TP}.robotImageAlt`, 'Model wearing {productName}', { productName })}
      sizes="100px"
      disableLazyLoad
      src={url || ''}
      onClick={handleClick}
    />
  </RobotImage.Wrapper>
);

RobotImage.Wrapper = styled.div<{
  isSelected: boolean;
}>`
  > img {
    height: 100%;
    object-fit: cover;
    width: 60px;
    overflow: hidden;
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      opacity: 0.5;
    `}
`;
